<template>
    <div>
        <form method="post" @submit.prevent="submit">
            <div v-for="(host, i) in hoste" :key="i" class="mt-11 first:mt-5">
                <div class="flex justify-between items-center mt-10">
                    <div class="flex-1 flex items-center space-x-3">
                        <div class="flex-none flex justify-center items-center w-9 h-9 pl-1 text-18 font-bold bg-gray-100 rounded-full">{{ i + 1 }}.</div>
                        <h2 class="h2 mt-0">{{ trans.get('rezervace.checkin_host') }}</h2>
                    </div>

                    <button v-if="i > 0" @click="odstranHosta(i)" type="button" class="link">{{ trans.get('rezervace.checkin_odstranit') }}</button>
                </div>

                <div class="md:flex mt-5 md:space-x-4">
                    <div class="md:w-1/2">
                        <label class="text-15">{{ trans.get('rezervace.kontakty_jmeno') }}:
                            <input v-model="host.jmeno" type="text" maxlength="15" name="jmeno" autocomplete="given-name" :class="'form-input form-control w-full' + (errors && errors['hoste.' + i + '.jmeno'] ? ' border-red-700' : '')">
                        </label>

                        <div v-if="errors && errors['hoste.' + i + '.jmeno']" class="validation-error">{{ errors['hoste.' + i + '.jmeno'][0] }}</div>
                    </div>

                    <div class="md:w-1/2 mt-4 md:mt-0">
                        <label class="text-15">{{ trans.get('rezervace.kontakty_prijmeni') }}:
                            <input v-model="host.prijmeni" type="text" maxlength="30" name="prijmeni" autocomplete="family-name" :class="'form-input form-control w-full' + (errors && errors['hoste.' + i + '.prijmeni'] ? ' border-red-700' : '')">
                        </label>

                        <div v-if="errors && errors['hoste.' + i + '.prijmeni']" class="validation-error">{{ errors['hoste.' + i + '.prijmeni'][0] }}</div>
                    </div>
                </div>

                <div class="md:flex md:space-x-4 mt-4">
                    <div class="md:w-1/2">
                        <label class="text-15">{{ trans.get('rezervace.kontakty_ulice') }}:
                            <input v-model="host.ulice" type="text" maxlength="30" name="ulice" autocomplete="address-line1" :class="'form-input form-control w-full' + (errors && errors['hoste.' + i + '.ulice'] ? ' border-red-700' : '')">
                        </label>

                        <div v-if="errors && errors['hoste.' + i + '.ulice']" class="validation-error">{{ errors['hoste.' + i + '.ulice'][0] }}</div>
                    </div>

                    <div class="md:w-1/2 mt-4 md:mt-0">
                        <div class="flex space-x-4">
                            <div class="w-1/3">
                                <label class="text-15">{{ trans.get('rezervace.kontakty_psc') }}:
                                    <input v-model="host.psc" type="text" maxlength="10" name="psc" autocomplete="postal-code" :class="'form-input form-control w-full' + (errors && errors['hoste.' + i + '.psc'] ? ' border-red-700' : '')">
                                </label>

                                <div v-if="errors && errors['hoste.' + i + '.psc']" class="validation-error">{{ errors['hoste.' + i + '.psc'][0] }}</div>
                            </div>

                            <div class="w-2/3 mt-0">
                                <label class="text-15">{{ trans.get('rezervace.kontakty_mesto') }}:
                                    <input v-model="host.mesto" type="text" maxlength="40" name="mesto" autocomplete="address-level2" :class="'form-input form-control w-full' + (errors && errors['hoste.' + i + '.mesto'] ? ' border-red-700' : '')">
                                </label>

                                <div v-if="errors && errors['hoste.' + i + '.mesto']" class="validation-error">{{ errors['hoste.' + i + '.mesto'][0] }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-4">
                    <label class="text-15">{{ trans.get('rezervace.kontakty_stat') }}:
                        <select v-model="host.stat" name="stat" autocomplete="country" :class="'form-select form-control w-full' + (errors && errors['hoste.' + i + '.stat'] ? ' border-red-700' : '')">
                            <option value="">{{ trans.get('rezervace.kontakty_stat_vychozi') }}</option>

                            <optgroup :label="trans.get('rezervace.kontakty_stat_nejcastejsi')">
                                <option v-for="stat in statyCaste" :key="stat.id_staty" :value="stat.kod">{{ stat.nazev_klient }}</option>
                            </optgroup>

                            <optgroup :label="trans.get('rezervace.kontakty_stat_ostatni')">
                                <option v-for="stat in statyOstatni" :key="stat.id_staty" :value="stat.kod">{{ stat.nazev_klient }}</option>
                            </optgroup>
                        </select>
                    </label>

                    <div v-if="errors && errors['hoste.' + i + '.stat']" class="validation-error">{{ errors['hoste.' + i + '.stat'][0] }}</div>
                </div>

                <div class="md:flex mt-5 md:space-x-4">
                    <div class="md:w-1/4">
                        <label class="text-15">{{ trans.get('rezervace.checkin_datum_narozeni') }}:
                            <input v-model="host.datum_narozeni" type="text" maxlength="10" name="datum_narozeni" :class="'form-input form-control w-full' + (errors && errors['hoste.' + i + '.datum_narozeni'] ? ' border-red-700' : '')">
                        </label>

                        <div v-if="errors && errors['hoste.' + i + '.datum_narozeni']" class="validation-error">{{ errors['hoste.' + i + '.datum_narozeni'][0] }}</div>
                    </div>

                    <div class="md:w-1/4 mt-4 md:mt-0">
                        <label class="text-15">{{ trans.get('rezervace.checkin_osobni_prukaz') }}:
                            <input v-model="host.osobni_prukaz" type="text" maxlength="30" name="osobni_prukaz" :disabled="host.nema_osobni_prukaz" :class="'form-input form-control w-full' + (errors && errors['hoste.' + i + '.osobni_prukaz'] ? ' border-red-700' : '') + (hoste[i].nema_osobni_prukaz ? ' bg-gray-100' : '')">
                        </label>

                        <div v-if="errors && errors['hoste.' + i + '.osobni_prukaz']" class="validation-error">{{ errors['hoste.' + i + '.osobni_prukaz'][0] }}</div>

                        <label class="text-15">
                            <input v-model="host.nema_osobni_prukaz" @change="toggleNemaPrukaz(i)" type="checkbox" name="nema_osobni_prukaz" class="form-checkbox form-control mr-1">
                            {{ trans.get('rezervace.checkin_nema_osobni_prukaz') }}
                        </label>
                    </div>

                    <div class="md:w-1/4 mt-4 md:mt-0">
                        <label class="text-15">{{ trans.get('rezervace.checkin_cislo_viza') }} ({{ trans.get('rezervace.ostatni_nepovinne') }}):
                            <input v-model="host.cislo_viza" type="text" maxlength="20" name="cislo_viza" :class="'form-input form-control w-full' + (errors && errors['hoste.' + i + '.cislo_viza'] ? ' border-red-700' : '')">
                        </label>

                        <div v-if="errors && errors['hoste.' + i + '.cislo_viza']" class="validation-error">{{ errors['hoste.' + i + '.cislo_viza'][0] }}</div>
                    </div>

                    <div class="md:w-1/4 mt-4 md:mt-0">
                        <label class="text-15">{{ trans.get('rezervace.checkin_ucel_pobytu') }}:
                            <select v-model="host.ucel_pobytu" name="ucel_pobytu" :class="'form-select form-control w-full' + (errors && errors['hoste.' + i + '.ucel_pobytu'] ? ' border-red-700' : '')">
                                <option v-for="ucelPobytu in ucelyPobytu" :key="ucelPobytu.value" :value="ucelPobytu.value">{{ ucelPobytu.label }}</option>
                            </select>
                        </label>

                        <div v-if="errors && errors['hoste.' + i + '.ucel_pobytu']" class="validation-error">{{ errors['hoste.' + i + '.ucel_pobytu'][0] }}</div>
                    </div>
                </div>
            </div>

            <button @click.prevent="pridejHosta" class="w-full py-5.5 mt-11 border-dashed border-2 border-gray-200 hover:border-blue-500 rounded-3 duration-300">{{ trans.get('rezervace.checkin_pridat') }}</button>

            <div class="mt-11">
                <div v-if="! sending">
                    <button type="submit" class="w-full py-4 text-18 font-semibold text-white bg-blue-500 hover:bg-blue-600 whitespace-nowrap rounded-3 duration-300">
                        {{ trans.get('rezervace.checkin_zapsat') }}
                    </button>
                </div>
                <div v-else>
                    <div class="flex items-center justify-center w-full py-4 text-18 font-semibold text-white text-center bg-blue-300 rounded-3 duration-300 cursor-not-allowed">
                        <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>

                        <div class="ml-2 md:ml-4">
                            {{ trans.get('rezervace.checkin_zapsat') }}
                        </div>
                    </div>
                </div>

                <div class="mt-6 text-center">
                    <a :href="'/objednavka/' + objednavka.uuid" class="link mx-auto">{{ trans.get('rezervace.checkin_zpet') }}</a>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: {
        objednavka: Object,
        statyCaste: Array,
        statyOstatni: Array,
        ucelyPobytu: Array,
    },

    data: function () {
        return {
            hoste: [],
            errors: {},
            sending: false,
        }
    },

    methods: {
        submit() {
            this.errors = {};
            this.sending = true;

            axios.post('/objednavka/' + this.objednavka.uuid + '/checkin', {'hoste': this.hoste})
                .then(response => {
                    window.location = response.data.redirect_url;
                }).catch(error => {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors || {};
                    this.sending = false;
                }
            });
        },

        pridejHosta() {
            this.hoste.push(this.nactiHosta());
        },

        odstranHosta(i) {
            this.hoste.splice(i, 1);
        },

        nactiHosta() {
            return {
                prijmeni: this.hoste.length === 0 ? this.objednavka.prijmeni : '',
                jmeno: this.hoste.length === 0 ? this.objednavka.jmeno : '',
                ulice: this.hoste.length === 0 ? this.objednavka.ulice : '',
                mesto: this.hoste.length === 0 ? this.objednavka.mesto : '',
                psc: this.hoste.length === 0 ? this.objednavka.psc : '',
                datum_narozeni: '',
                osobni_prukaz: '',
                nema_osobni_prukaz: false,
                cislo_viza: '',
                stat: this.hoste.length === 0 ? this.objednavka.stat : '',
                ucel_pobytu: 'Turistika',
            };
        },

        toggleNemaPrukaz(i) {
            if (this.hoste[i].nema_osobni_prukaz) {
                this.hoste[i].osobni_prukaz = '';
            }
        }
    },

    computed: {
        odeslat: function () {
            return (this.hoste.length > 0) && (this.hoste.filter(host => host.prijmeni).length > 0);
        },
    },

    created() {
        this.pridejHosta();
    }
}
</script>
